import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { SvgIcon, TextField } from "@mui/material";
import BryxColors from "../types/theme";
const BryxTimeSubInput = styled((props) => {
    const arrowStyling = {
        position: "relative",
        width: "0.6666rem",
        height: "0.6666rem",
        padding: "2px 0",
    };
    const upArrowStyling = {
        ...arrowStyling,
        top: "1.43333rem",
        left: "-1.3333rem",
    };
    const downArrowStyling = {
        ...arrowStyling,
        top: "calc(100% - 3.222222rem)",
        left: "-2rem",
    };
    const onUpArrowClick = () => {
        props.onChange(props.value + 1);
    };
    const onDownArrowClick = () => {
        props.onChange(props.value - 1);
    };
    return (_jsxs("div", { children: [_jsx(TextField, { ...props, variant: "outlined", error: props.error, helperText: props.errorText ?? " ", placeholder: props.placeholder, label: props.label ?? null, type: "number", style: { width: "71px" }, onChange: (e) => props.onChange(parseInt(e.target.value, 10) || 0) }), _jsx(SvgIcon, { viewBox: "0 0 8 5", sx: upArrowStyling, onClick: onUpArrowClick, children: _jsx("path", { d: "M1.22595 4.7779L4.00358 1.83181L6.78121 4.7779C7.0604 5.07403 7.51141 5.07403 7.7906 4.7779C8.0698 4.48178 8.0698 4.00342 7.7906 3.70729L4.5047 0.222096C4.2255 -0.0740318 3.7745 -0.0740318 3.4953 0.222096L0.209396 3.70729C-0.0697987 4.00342 -0.0697987 4.48178 0.209396 4.7779C0.488591 5.06644 0.946756 5.07403 1.22595 4.7779Z" }) }), _jsx(SvgIcon, { viewBox: "0 0 8 5", sx: downArrowStyling, onClick: onDownArrowClick, children: _jsx("path", { d: "M1.22595 0.222096L4.00358 3.16819L6.78121 0.222096C7.0604 -0.0740319 7.51141 -0.0740319 7.7906 0.222096C8.0698 0.518223 8.0698 0.996583 7.7906 1.29271L4.5047 4.7779C4.2255 5.07403 3.7745 5.07403 3.4953 4.7779L0.209396 1.29271C-0.0697987 0.996583 -0.0697987 0.518223 0.209396 0.222096C0.488591 -0.0664389 0.946756 -0.0740319 1.22595 0.222096Z" }) })] }));
})(({ theme, error }) => {
    const pallete = theme.palette.mode;
    return {
        "& .MuiInputBase-root": {
            padding: "12px 16px",
            fontFamily: "Open Sans",
            fontSize: "13px",
            color: error
                ? BryxColors.notify(pallete, "error")
                : pallete == "light"
                    ? BryxColors.brand(pallete, -2)
                    : BryxColors.brand("dark", 4),
            backgroundColor: pallete == "dark" && BryxColors.DarkMode.specialColors.popupBackground,
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: error ? BryxColors.notify(pallete, "error") : BryxColors.notify(pallete, "inactive"),
            "& input": {
                padding: "0px",
                border: "none",
                "&:focus": {
                    outline: "none",
                },
            },
            "& input[type=number]": {
                MozAppearance: "textfield",
            },
            '& input[type="number"]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button': {
                WebkitAppearance: "none",
                margin: 0,
            },
            "& fieldset": {
                display: "none",
            },
            "&.Mui-focused": {
                borderWidth: "1px",
                borderColor: (error
                    ? BryxColors.notify(pallete, "error")
                    : pallete == "light"
                        ? BryxColors.brand(pallete, -2)
                        : BryxColors.brand("dark", 4)) + " !important",
            },
            "& legend": {
                display: "none",
            },
        },
        "& .MuiFormHelperText-root": {
            marginTop: "4px",
            marginLeft: "0px",
            fontSize: "13px",
            fontFamily: "Open Sans",
            color: BryxColors.notify(pallete, "error"),
        },
        "& .MuiFormLabel-root": {
            color: error
                ? BryxColors.notify(pallete, "error")
                : pallete == "light"
                    ? BryxColors.brandDark2(pallete)
                    : BryxColors.brand4(pallete),
            fontFamily: "Open Sans",
            marginBottom: "8px",
            // disable mui glide to top animation
            position: "relative !important",
            transform: "translate(0px, 0px) !important",
            fontSize: "13px",
            height: "13px",
            display: "flex",
            alignItems: "center",
            "&.Mui-focused": {
                color: (error
                    ? BryxColors.notify(pallete, "error")
                    : pallete == "light"
                        ? BryxColors.brand(pallete, -2)
                        : BryxColors.brand("dark", 4)) + " !important",
            },
        },
        "& ~ .MuiSvgIcon-root:hover": {
            fill: BryxColors.brand1(pallete),
        },
    };
});
export default BryxTimeSubInput;
